import React, { useEffect, useRef } from "react";
import "react-tabs/style/react-tabs.css";
import Paradigm from "../../Student/Paradigm/Paradigm";
import NameAndNum from "../../../../components/BUAP/Student/Information/NameAndNum";
import axios from "../../../../axios/BUAP/students";
import GetToken from "../../../../Shared/GetToken";
import ReactToPrint from "react-to-print";
import { Button } from "react-bootstrap";
import * as actionCreators from "../../../../store/actions/BUAP/BUAP";
import { connect } from "react-redux";

const StudentInfoForAdviseeList = (props) => {
  const refPR = useRef();
  useEffect(() => {
    //Used to generate paradigm and student degree if they are not generated
    axios
      .get("StudentDegree/" + props.studentno, {
        headers: { Authorization: GetToken("token") },
      })
      .then((response) => {
        props.setstudentdegree(response.data);
      });
  }, [props, props.studentno]);

  return (
    <React.Fragment>
      <div style={{ textAlign: "right" }}>
        <ReactToPrint
          bodyClass="print-agreement"
          content={() => refPR.current}
          trigger={() => <Button type="primary">Print</Button>}
        />
      </div>
      <div ref={refPR}>
        <div className="showonprint">
          <NameAndNum />
        </div>
        <Paradigm />
      </div>
    </React.Fragment>
  );
};

//Redux
const mapDispatchToProps = (dispatch) => {
  return {
    setstudentdegree: (e) => dispatch(actionCreators.setstudentdegree(e)),
  };
};

export default connect(null, mapDispatchToProps)(StudentInfoForAdviseeList);
